const enum AddToCartErrorEnum {
  mixedCart = 'ZERO_AUTH_REGULAR_ITEM_MIXED_CART',
  maxProductQuantity = 'MAX_QUANTITY_OF_PRODUCT_EXCEEDED',
  maxBasketQuantity = 'MAX_QUANTITY_OF_BASKET_EXCEEDED',
  maxBasketValue = 'MAX_VALUE_OF_BASKET_EXCEEDED',
}

export default AddToCartErrorEnum;
